import type { Message } from '../../model/types'

import { api } from '../../api'
import { useCurrentId } from '../../hooks'
import css from './style.module.scss'

export function Reactions({
	message_id: message,
	reaction_summaries: reactions
}: Message) {
	const [react, options] = api.useReactionMutation()
	const conversation = useCurrentId()

	function isNotReadyYet(emoji: string) {
		const isSameMessage = options.originalArgs?.message === message
		const isSameEmoji = options.originalArgs?.emoji === emoji

		return options.isLoading && isSameMessage && isSameEmoji
	}

	return (
		reactions.length > 0 && (
			<div className={css.reacts}>
				{reactions.map(({ count, emoji, viewerReacted }) => (
					<button
						className={css.item}
						disabled={isNotReadyYet(emoji)}
						key={emoji}
						onClick={() =>
							react({ conversation, emoji, mark: !viewerReacted, message })
						}
						type='button'
					>
						{emoji} {count}
					</button>
				))}
			</div>
		)
	)
}
